const FreeCard = () => {
  return (
    <div className="relative mt-14 flex w-[256px] justify-center rounded-[20px] bg-blue-400 pb-4">
      <div className="absolute -top-12 flex h-24 w-24 items-center justify-center rounded-full border-[4px] border-white bg-blue-400">
      </div>

      <div className="mt-16 flex h-fit flex-col items-center text-white">
        <div className="text-sm font-semibold">C-ONE</div>
        <div className="text-xs mt-1 text-white/90">Dashboard</div>
      </div>
    </div>
  );
};

export default FreeCard;
